export default __webpack_public_path__ + "static/media/contentservice1.55b276ab.png";